import { render, staticRenderFns } from "./Dokumente.vue?vue&type=template&id=0f5de7c7&"
import script from "./Dokumente.vue?vue&type=script&lang=ts&"
export * from "./Dokumente.vue?vue&type=script&lang=ts&"
import style0 from "./Dokumente.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports